// src/routes/waypoint/$sessionId.debrief.tsx
import { useParams } from "@tanstack/react-router";
import { DebriefScreen } from "@/components/waypoint/DebriefScreen";
import { useWaypointSession } from "@/hooks/use-waypoint-sessions";

export function WaypointDebriefPage() {
  const { sessionId } = useParams({ strict: false });
  const { data: session, isLoading, isError } = useWaypointSession(sessionId);

  // "active" = WS just closed, orch.end() still writing; "ended" = debrief generating
  const isGenerating =
    (session?.status === "ended" || session?.status === "active") && !session?.debrief;

  if (isLoading || isGenerating) {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: 16,
          padding: "80px 0",
        }}
      >
        <div
          style={{
            width: 40,
            height: 40,
            borderRadius: "50%",
            border: "3px solid rgba(0,24,71,0.08)",
            borderTop: "3px solid #407EC1",
            animation: "spin 0.9s linear infinite",
          }}
        />
        <p
          style={{
            fontFamily: "'Montserrat', sans-serif",
            fontWeight: 600,
            fontSize: 14,
            color: "#64748b",
            margin: 0,
          }}
        >
          Generating your debrief…
        </p>
        <p style={{ fontSize: 12, color: "#94a3b8", margin: 0 }}>
          This usually takes 15–30 seconds
        </p>
      </div>
    );
  }

  if (isError || !session?.debrief) {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: 8,
          padding: "80px 0",
        }}
      >
        <p
          style={{
            fontFamily: "'Montserrat', sans-serif",
            fontWeight: 600,
            fontSize: 15,
            color: "#001847",
            margin: 0,
          }}
        >
          Debrief not available
        </p>
        <p style={{ fontSize: 13, color: "#94a3b8", margin: 0 }}>
          The session may still be processing. Try refreshing the page.
        </p>
      </div>
    );
  }

  return <DebriefScreen session={session} debrief={session.debrief} />;
}
